import React from "react";
import style from "./index.module.scss";

const Empty = () => {
    return (
        <div className={style.root}>
            <img src={require("./img/bg.png")} className={style.imgStyle} />
            <div className={style.tip}>暂无消息</div>
        </div>
    );
};
export default Empty;
